import { render, staticRenderFns } from "./Dmca.vue?vue&type=template&id=4e2f5e70&scoped=true"
import script from "./Dmca.vue?vue&type=script&lang=js"
export * from "./Dmca.vue?vue&type=script&lang=js"
import style0 from "./Dmca.vue?vue&type=style&index=0&id=4e2f5e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f5e70",
  null
  
)

export default component.exports